import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.type === 'individual')
    ? _renderSlot(_ctx.$slots, "individual", { key: 0 })
    : (_ctx.type === 'company')
      ? _renderSlot(_ctx.$slots, "company", { key: 1 })
      : _createCommentVNode("", true)
}